import React, { useEffect } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { PageHero } from './PageHero';
import { Mail as MailIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export interface FederationMember {
  name: string;
  role: string;
  email?: string;
  photo?: string;
}
interface FederationMembersPageProps {
  title: string;
  subtitle?: string;
  members: FederationMember[];
}
export function FederationMembersPage({
  title,
  subtitle,
  members
}: FederationMembersPageProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-gray-50" data-id="element-118">
      <Header data-id="element-119" />
      <main className="pt-20" data-id="element-120">
        <PageHero label="Федерація" title={title} subtitle={subtitle} data-id="element-121" />

        {/* Members List */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-20" data-id="element-122">
          <div className="space-y-6" data-id="element-123">
            {members.map((member, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.08,
            duration: 0.4
          }} className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 flex flex-col sm:flex-row items-center sm:items-start gap-6" data-id="element-124">
                {/* Photo */}
                <div className="w-28 h-28 rounded-full overflow-hidden bg-gray-100 flex-shrink-0 border-2 border-gray-200" data-id="element-125">
                  {member.photo ? <img src={member.photo} alt={member.name} className="w-full h-full object-cover" data-id="element-126" /> : <div className="w-full h-full flex items-center justify-center bg-primary/5 text-primary/30" data-id="element-127">
                      <span className="text-3xl font-bold" data-id="element-128">
                        {member.name.charAt(0)}
                      </span>
                    </div>}
                </div>

                {/* Info */}
                <div className="text-center sm:text-left" data-id="element-129">
                  <h3 className="text-lg font-bold text-primary" data-id="element-130">
                    {member.name}
                  </h3>
                  <p className="text-sm font-medium text-gray-500 mt-1" data-id="element-131">
                    {member.role}
                  </p>
                  {member.email && <a href={`mailto:${member.email}`} className="inline-flex items-center gap-1.5 mt-3 text-sm text-primary/70 hover:text-primary transition-colors" data-id="element-132">
                      <MailIcon className="h-3.5 w-3.5" data-id="element-133" />
                      {member.email}
                    </a>}
                </div>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-134" />
    </div>;
}